'use client';
import { useTranslations } from 'next-intl';
import { useContext } from 'react';
import { PageContext } from '@/features/app-providers/page-provider';
import { Icon } from '@/shared/ui/icon';
import { BottomPanelTab } from './bottom-panel-tab';
import { BottomPanelTabIconWrapper } from './bottom-panel-tab-icon-wrapper';
import { BottomPanelTabPremadeProps } from './types';

type Props = BottomPanelTabPremadeProps;
export const BottomPanelHomeTab = (props: Props) => {
    const t = useTranslations();
    const { pageName } = useContext(PageContext);

    return (
        <BottomPanelTab
            icon={
                <BottomPanelTabIconWrapper>
                    <Icon name="home" width={24} height={24} />
                </BottomPanelTabIconWrapper>
            }
            href="/"
            title={t('BOTTOM_PANEL.HOME')}
            {...props}
            data-testid="bottom-panel-home-tab"
            isActive={pageName === 'home'}
        />
    );
};
